import {
  Form,
  FormControl,
  FormField,
  FormItem,
} from "@spz/ui/components/form";
import { SearchableCheckboxTreeField } from "@spz/ui/components/searchable-checkbox-tree-field";
import { Section } from "@spz/ui/components/section";
import { Textarea } from "@spz/ui/components/textarea";
import { TextField } from "@spz/ui/components/textfield";
import { cn } from "@spz/ui/lib/utils";
import { t } from "i18next";
import type { Ref } from "react";
import { selectUserGroupsFormViewModel } from "./user-groups-form.view-model";

interface UserGroupsFormProps {
  groupId?: string;
  className?: string;
  onSuccess?: () => void;
  ref?: Ref<HTMLFormElement>;
}
export const UserGroupsForm = ({
  className,
  onSuccess,
  groupId,
  ref,
}: UserGroupsFormProps) => {
  const { form, onSubmit, users } = selectUserGroupsFormViewModel({
    onSuccess,
    groupId,
  });
  return (
    <Section
      title={groupId ? t("group_form_edit_title") : t("create_new_group")}
      description={t("users_group_form_description")}
      className={cn("gap-4 px-6 pb-6", className)}
      darken
    >
      <Form {...form}>
        <form
          ref={ref}
          onSubmit={onSubmit}
          id="users-group-form"
          className="flex flex-col gap-4"
        >
          <FormField
            control={form.control}
            name="name"
            render={({ field, fieldState }) => (
              <FormItem>
                <FormControl>
                  <TextField
                    {...field}
                    value={field.value || ""}
                    placeholder={t("group_name")}
                    className="w-full"
                    floatingPlaceholder
                    helperText={t("users_group_form_name_helper_text")}
                    error={fieldState.error}
                  />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="description"
            render={({ field, fieldState }) => (
              <FormItem>
                <FormControl>
                  <Textarea
                    {...field}
                    placeholder={t("description")}
                    className="min-h-10 max-h-13"
                    helperText={t("users_group_form_description_helper_text")}
                    error={fieldState.error}
                  />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="users"
            render={({ field, fieldState }) => (
              <SearchableCheckboxTreeField
                label={t("users_group_management_title")}
                description={t("users_list_group_form_description")}
                searchPlaceholder={t("users_group_form_search_placeholder")}
                emptyList={t("no_users")}
                loading={users.loading}
                options={users.options}
                value={field.value?.map(String)}
                onChange={({ selectedIds }) => {
                  field.onChange(selectedIds);
                  field.onBlur();
                }}
                error={fieldState.error}
              />
            )}
          />
        </form>
      </Form>
    </Section>
  );
};
